import { $color_grey_8, $color_grey_5, $color_grey_7, $color_grey_9, $color_grey_2 } from '../pebbleGlobalToken/color.js';

/**
 * 树选择-颜色-文本
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $tree_select_color_text = $color_grey_8;

/**
 * 树选择-颜色-边框-默认
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $tree_select_border_default_color = $color_grey_5;

/**
 * 树选择-颜色-边框-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $tree_select_border_hover_color = $color_grey_7;

/**
 * 树选择-颜色-边框-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $tree_select_border_active_color = $color_grey_9;

/**
 * 树选择-颜色-背景-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $tree_select_background_hover_color = $color_grey_2;
/**
 * 树选择-颜色-文字-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $tree_select_font_hover_color = $color_grey_9;

export { $tree_select_background_hover_color, $tree_select_border_active_color, $tree_select_border_default_color, $tree_select_border_hover_color, $tree_select_color_text, $tree_select_font_hover_color };
